import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicCheckbox, Loader } from 'core/components';

const VoidLabelTemplate = ({ t, voidLabelViewStore: { form, onCheck, loading, voidOnChannel, modalParams } }) => {
	if (loading) return <Loader />;
	return (
		<section>
			<form className="ReactModal__form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<p className="spc--bottom--sml">{t('VOIDLABELCONFIRMATIONVIEW.MESSAGE')}</p>

					{form.error != null && <p className="type--color--warning">{translate(form.error)}</p>}

					<div className="spc--bottom--sml">
						<label className="display--b">{t('VOIDLABELCONFIRMATIONVIEW.VOIDONCHANNEL')}</label>
						<div>
							<BaasicCheckbox
								id={'voidOnChannel'}
								onChangeCallback={onCheck}
								checked={voidOnChannel}
								className="input--toggle input--toggle--secondary"
							/>
						</div>
					</div>
				</div>
				<div className="ReactModal__footer">
					<button className="btn btn--med btn--primary spc--bottom--sml" type="submit">
						{t('Void')}
					</button>
					<button className="btn btn--med btn--ghost spc--bottom--sml" onClick={() => modalParams.close()}>
						{t('CANCEL')}
					</button>
				</div>
			</form>
		</section>
	);
};

export default defaultTemplate(VoidLabelTemplate);
